module.exports = __webpack_public_path__ + "img/footer-ojk.30b196a4.webp";